import * as React from 'react'

import { cn } from '@shared/ui/lib/utils'
import './input.css'

export interface InputProps extends React.ComponentPropsWithoutRef<'input'> {
  readonly fullWidth?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  {
    className,
    fullWidth = true,
    type = 'text',
    ...props
  },
  ref,
) {
  return (
    <input
      className={cn(
        'min-h-11 rounded-md border px-3.5 py-2.5 text-sm outline-none transition-[background-color,border-color,box-shadow,color] duration-150',
        fullWidth ? 'w-full' : 'w-auto',
        className,
      )}
      data-slot="input"
      ref={ref}
      type={type}
      {...props}
    />
  )
})

export { Input }
